// extracted by mini-css-extract-plugin
module.exports = {"className":"ko-KR_className__ZLYCk"};